export default __webpack_public_path__ + "static/media/goalPage@2x.2893ff4b.png";